// TA Draft (ta-draft-next): the live site.  In development the app looks for a local TA Draft
// first; always get the base URL from getDraftBaseUrl() in utils/draftBase.ts.
export const TA_DRAFT_API_BASE_PROD = 'https://draft.lmucs.org'

// This app's own endpoint that reports where TA Draft was found (api/_lib/draftApi.js)
export const DRAFT_BASE_API_PATH = '/api/draft-base'

export const DRAFT_BASE_CACHE_MS = 60000

// This app's own endpoint for the /roster page (api/_lib/recruitApi.js)
export const ROSTER_API_PATH = '/api/roster'

export const PLACEHOLDER_PHOTO_PATH = 'images/placeholders/placeholder.jpg'

export const TA_DRAFT_SHEET_API_PATH = '/api/ta-draft-sheet'
export const TA_DRAFT_PUBLIC_SHIFTS_API_PATH = '/api/public/shifts'
